module.exports = __webpack_public_path__ + "resources/img/img_coolfilter7.2c78d1fcfa91a75f3f5b50b1ab55c14e.png";